import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import { LazyLoadingComponent } from './LazyLoadingComponent/LazyLoadingComponent'
import './Visible.scss'

interface VisibleProps {
  visible?: boolean
  noVisibleIfRender?: boolean
}

export const Visible = defineComponent<VisibleProps>({
  props: DefineComponentProps<VisibleProps>(['visible', 'noVisibleIfRender']),
  setup(props, { slots }) {
    const { noVisibleIfRender = true } = props
    return () => (
      <div
        class={classNames('visible-layout', {
          block: props.visible,
          none: !props.visible,
        })}
      >
        <LazyLoadingComponent>{!noVisibleIfRender && !props.visible ? null : slots.default?.()}</LazyLoadingComponent>
      </div>
    )
  },
})
